/**
 * Utility functions for difficulty levels
 */

/**
 * Get MUI color for difficulty level
 * @param {string} difficulty - Difficulty level
 * @returns {string} MUI color name
 */
export const getDifficultyColor = (difficulty) => {
  switch (difficulty?.toLowerCase()) {
    case 'beginner':
    case 'начинающий':
      return 'success';
    case 'intermediate':
    case 'средний':
      return 'warning';
    case 'advanced':
    case 'продвинутый':
      return 'error';
    default:
      return 'default';
  }
};

/**
 * Get hex color for difficulty level (for custom styling)
 * @param {string} difficulty - Difficulty level
 * @returns {string} Hex color code
 */
export const getDifficultyHexColor = (difficulty) => {
  switch (difficulty?.toLowerCase()) {
    case 'beginner':
    case 'начинающий':
      return '#48BB78'; // Green
    case 'intermediate':
    case 'средний':
      return '#ED8936'; // Orange
    case 'advanced':
    case 'продвинутый':
      return '#E53E3E'; // Red
    default:
      return '#718096'; // Gray
  }
};

/**
 * Get difficulty label with proper capitalization
 * @param {string} difficulty - Difficulty level
 * @returns {string} Formatted difficulty label
 */
export const getDifficultyLabel = (difficulty) => {
  if (!difficulty) return 'BEGINNER';
  
  return difficulty.toUpperCase();
};
